import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import {Language} from '../../../auth-module/model/language';
import {AppState, getTreeLabels, HighlightSelectionType} from '../../../state-management/reducers';

import {LabelSettings} from '../../../state-management/reducers/view-options.reducer';
import {
  LabelOptionsDialogComponent, LabelsOptionsDialogData
} from '../label-options-dialog/label-options-dialog.component';
import {LanguageChange} from '../language-selector';

@Component({
    selector: 'pm-view-options-menu',
    templateUrl: './view-options-menu.component.html',
    styleUrls: ['./view-options-menu.component.css'],
    standalone: false
})
export class ViewOptionsMenuComponent {
  @Input() currentLanguage: Language;
  @Input() translationHighlight: HighlightSelectionType = 'off';
  @Input() showHighlightButton = true;
  @Input() showUnsearchable = true;
  @Input() showBackLinks = false;

  @Input() labelSettings: LabelSettings = {
    show: true,
    inherit: false,
    descendents: false,
    enableFilter: false
  };

  @Output() languageChange: EventEmitter<LanguageChange> = new EventEmitter();
  @Output() labelChange: EventEmitter<LabelSettings> = new EventEmitter();
  @Output() highlightChange: EventEmitter<HighlightSelectionType> = new EventEmitter();
  @Output() showUnsearchableChange: EventEmitter<boolean> = new EventEmitter();
  @Output() showBackLinksChange: EventEmitter<boolean> = new EventEmitter();

  $treeLabels = this.store.select(getTreeLabels);

  constructor(private matDialog: MatDialog, private store: Store<AppState>) {
  }

  get isDefaultLanguage(): boolean {
    return this.currentLanguage && this.currentLanguage.isDefault;
  }

  highlightSelected(type: HighlightSelectionType) {
      this.highlightChange.emit(type);
  }

  openLabelsDialog() {
    this.$treeLabels.pipe(take(1)).subscribe((labels) => {
      this.matDialog.open<LabelOptionsDialogComponent, LabelsOptionsDialogData, LabelSettings>(LabelOptionsDialogComponent, {
        data: {
          availableLabels: labels,
          currentSettings: this.labelSettings
        }
      }).afterClosed().subscribe((value) => {
        this.labelChange.emit(value);
      })
    });
  }

  setShowUnsearchable($event: MatCheckboxChange) {
    this.showUnsearchableChange.emit($event.checked);
  }

  setShowBackLinks($event: MatCheckboxChange) {
    this.showBackLinksChange.emit($event.checked);
  }
}
